import React from "react";
import { Container } from "react-bootstrap";
import Particle from "./Particle";

function TermsOfService() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <div
          className="legal-content"
          style={{
            padding: "50px 20px",
            textAlign: "left",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "10px",
            marginTop: "120px",
            color: "#333",
          }}
        >
          <h1 style={{ textAlign: "center", marginBottom: "30px", color: "#2c3e50" }}>
            Terms of Service for Hangman Go
          </h1>

          <p><strong>Effective Date: October 2025</strong></p>

          <h3>1. Acceptance of Terms</h3>
          <p>
            By downloading, installing, or using the Hangman Go mobile application (“App”), you
            agree to be bound by these Terms of Service (“Terms”). If you do not agree, please
            do not use the App.
          </p>

          <h3>2. Description of Service</h3>
          <p>Hangman Go is a family-friendly word game featuring:</p>
          <ul>
            <li>Single-player, offline word puzzles across multiple worlds and levels</li>
            <li>Daily/weekly quests, badges, and progression systems</li>
            <li>Character and gallows theme customization</li>
            <li>Virtual items (e.g., gems, character/theme packs)</li>
            <li>Optional subscription (“Hangman Pro”) for premium features</li>
            <li>Advertising supported gameplay (e.g., AdMob)</li>
          </ul>
          <p>
            Some features may require an internet connection (e.g., purchases, updates, price
            validation). Availability of features can vary by device, region, and store policy.
          </p>

          <h3>3. Eligibility & Child Users</h3>
          <ul>
            <li>The App is intended for general audiences. Children should use it under a parent or guardian’s supervision.</li>
            <li>We do not knowingly solicit personal information from children. For details, see our Privacy Policy.</li>
            <li>Personalized ads may be limited for child users where required by law or platform policy.</li>
          </ul>

          <h3>4. Accounts & Game Data</h3>
          <ul>
            <li>No separate user registration is required to play.</li>
            <li>Game progress is stored locally on your device. Uninstalling or changing devices may result in data loss unless you use an available platform backup/sync solution.</li>
            <li>You are responsible for maintaining your device’s security and backups.</li>
          </ul>

          <h3>5. In-App Purchases & Virtual Items</h3>
          <ul>
            <li>The App offers optional in-app purchases, including consumables (e.g., gems) and non-consumables (e.g., themes/characters).</li>
            <li>Virtual items have no real-world monetary value, are non-transferable, and are licensed—not sold—for personal, non-commercial use within the App.</li>
            <li>All transactions are processed by Apple App Store or Google Play; store terms govern billing, refunds, and error handling.</li>
            <li>Except where required by law, purchases are final and non-refundable.</li>
          </ul>

          <h3>6. Subscriptions (Auto-Renewing)</h3>
          <ul>
            <li>“Hangman Pro” (name may vary by store) is an auto-renewing subscription that unlocks premium/features (e.g., ad-light experience, bonuses, or additional content as described on the product page).</li>
            <li>Payment is charged to your store account at confirmation of purchase and upon renewal unless canceled at least 24 hours before the current period ends.</li>
            <li>Manage or cancel your subscription in your store account settings. Deleting the App does not cancel a subscription.</li>
            <li>Free trials (if offered) convert to a paid plan unless canceled before trial ends. Unused portions of a free trial may be forfeited when you purchase a subscription.</li>
            <li>Price changes: if applicable, you will be notified by the store and may need to accept the new price to continue.</li>
          </ul>

          <h3>7. Advertising</h3>
          <ul>
            <li>The App displays third-party advertisements (e.g., Google AdMob). We do not control third-party ad content.</li>
            <li>Rewarded ads (if any) grant in-game rewards upon complete viewing; availability is not guaranteed.</li>
            <li>Ad blocking or limiting ad tracking may affect certain features or rewards.</li>
          </ul>

          <h3>8. Acceptable Use</h3>
          <p>You agree to use the App only for lawful purposes and in accordance with these Terms. You may not:</p>
          <ul>
            <li>Reverse engineer, decompile, or attempt to extract source code</li>
            <li>Use the App for commercial purposes without our written permission</li>
            <li>Interfere with or disrupt the App, servers, networks, or security</li>
            <li>Use bots, scripts, or other automated means to access or manipulate the App</li>
          </ul>

          <h3>9. Intellectual Property</h3>
          <ul>
            <li>All App content—including software, artwork, animations, text, UI, audio, and design—is owned by or licensed to the developer and protected by applicable laws.</li>
            <li>You may not copy, modify, distribute, sell, or create derivative works from the App or its content except as expressly permitted by these Terms or by law.</li>
          </ul>

          <h3>10. Third-Party Services</h3>
          <p>
            The App may integrate third-party services (e.g., app stores, payment processors, analytics/entitlements, ad networks). Your use of such services is subject to their terms and privacy policies. See our Privacy Policy for more information.
          </p>

          <h3>11. Privacy</h3>
          <p>
            Your privacy is important to us. Please review our Privacy Policy, which explains what data may be processed (including by third parties), how it is used, and your choices. Store-level privacy disclosures also apply.
          </p>

          <h3>12. Disclaimers</h3>
          <ul>
            <li>The App is provided “as is” and “as available,” without warranties of any kind, express or implied.</li>
            <li>We do not guarantee uninterrupted or error-free operation, compatibility with every device, or that defects will be corrected.</li>
          </ul>

          <h3>13. Limitation of Liability</h3>
          <ul>
            <li>To the fullest extent permitted by law, we are not liable for indirect, incidental, special, consequential, or punitive damages, or for loss of data, opportunity, or profits.</li>
            <li>Where liability cannot be excluded, it is limited to the total amount you paid for in-app purchases and subscriptions within the twelve (12) months preceding the claim.</li>
          </ul>

          <h3>14. Suspension & Termination</h3>
          <ul>
            <li>You may stop using the App at any time by deleting it from your device.</li>
            <li>We may suspend or terminate access for violations of these Terms or where required by law or platform policies.</li>
            <li>Upon termination, rights granted under these Terms cease immediately; virtual items and progress may be lost.</li>
          </ul>

          <h3>15. Changes to the App or Terms</h3>
          <ul>
            <li>We may update the App, content, pricing, and these Terms from time to time.</li>
            <li>Material changes will be effective when posted in-App or via the store listing. Continued use after changes constitutes acceptance.</li>
            <li>We may discontinue the App or certain features at our discretion.</li>
          </ul>

          <h3>16. Governing Law & Jurisdiction</h3>
          <p>
            These Terms are governed by the laws of Türkiye. Unless mandatory law provides otherwise, disputes shall be resolved by the competent courts of İstanbul (Türkiye).
          </p>

          <h3>17. Consumer Rights</h3>
          <p>
            You may have statutory consumer rights under your local laws (including rights related to digital content and subscriptions). Nothing in these Terms limits such rights. Where applicable, refund and withdrawal requests must be submitted through the App Store or Google Play according to their policies.
          </p>

          <h3>18. Contact</h3>
          <p>If you have questions about these Terms, please contact:</p>
          <ul>
            <li>Email: sozdemircim@gmail.com</li>
          </ul>

          <h3>19. Severability</h3>
          <p>
            If any provision of these Terms is held invalid or unenforceable, the remaining provisions will remain in full force and effect.
          </p>

          <hr style={{ margin: "30px 0" }} />
          <p><strong>Last Updated: October 2025</strong></p>
        </div>
      </Container>
    </Container>
  );
}

export default TermsOfService;
